export default __webpack_public_path__ + "static/media/employeevetting.5a16a0d0.svg";